module.exports = __webpack_public_path__ + "static/media/Mama Rochel - All Registration Forms.7c304c0a.zip";